import { Editor } from 'tinymce'

/**
 * Box Types
 */
const boxColors = {
	'mds-attention': { label: 'Attention', icon: 'attention' },
	'mds-note': { label: 'Note', icon: 'note' },
} as const;
const boxColorKeys = Object.keys(boxColors) as (keyof typeof boxColors)[];


/**
 * Box Type Plugin
 */
export const registerBoxColors = (editor: Editor) => {
	editor.ui.registry.addMenuButton('box-color', {
		icon: 'info',
		tooltip: 'Box Farbe',
		onSetup: (api) => {
			const node = editor.selection.getNode()?.closest('.mds-box-format');
			if (!node) return () => undefined;

			Object.entries(boxColors).forEach(([key, entry]) => {
				if (node.classList.contains(key)) {
					api.setIcon(entry.icon);
				}
			})

			return () => undefined;
		},
		fetch: (cb, ctx, api) => {
			const node = editor.selection.getNode()?.closest('.mds-box-format');
			if (!node) return;

			const setTypeClass = (type?: keyof typeof boxColors) => {
				const addClass = type ? !node.classList.contains(type) : false;
				node.classList.remove(...boxColorKeys);
				if (addClass && type) node.classList.add(type);
				editor.dispatch('Change')
			};
			cb([
				{ 
					type: 'togglemenuitem', 
					value: 'normal', 
					text: 'Normal',
					icon: 'info',
					onAction: () => setTypeClass(), 
					active: !node.className.match(new RegExp(`(${boxColorKeys.join('|')})`))
				},
				...Object.entries(boxColors).map(([key, entry]) => ({
					type: 'togglemenuitem' as const,
					value: 'box-format-' + key,
					text: entry.label,
					icon: entry.icon,
					onAction: () => setTypeClass(key as keyof typeof boxColors),
					active: node.classList.contains(key)
				}))
			]);
		}
	})
}